import { useState, useEffect } from 'react';
import { useStores } from 'src/utils/useStore';
import { checkValue } from '../helper';


export const classTagDownGrader = (str) => {
  const level = checkValue(str) ? parseInt(str.slice(-1), 10) : undefined;
  return checkValue(str) && str.length > 0 && Number.isInteger(level) ? str.slice(0, -1) + (level + 1) : '';
};

type truncateOptionsTypes = {
  stripTags?: boolean;
  byWords?: boolean;
  keepWhitespaces?: boolean;
};

export const truncate = (html: string, maxLength: number, options: truncateOptionsTypes = {}): string => {
  const {
    sanityStore:{
      sanityPageData
    }
  } = useStores();

  // Text Trunkcate Logic From Sanity
  const isIgnoreTextTruncate = sanityPageData?.isIgnoreTextTruncate || false;

  if(!checkValue(html) || isIgnoreTextTruncate){
    return html;
  }
  
  const { stripTags = false, byWords = false, keepWhitespaces = false } = options;

  // Helper to remove HTML tags and return plain text
  const stripHtmlTags = (input: string) => input.replace(/<\/?[^>]+(>|$)/g, '');

  // Helper to truncate text based on the mode (characters or words)
  const truncateText = (text: string, maxLength: number, byWords: boolean): string => {
    if (byWords) {
      const words = text.trim().split(/\s+/);
      return words.length > maxLength ? words.slice(0, maxLength).join(' ') + '...' : text;
    } else {
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }
  };

  // Handle the case where tags should be stripped entirely
  if (stripTags) {
    const plainText = stripHtmlTags(html);
    return truncateText(plainText, maxLength, byWords);
  }

  // Helper to preserve HTML structure while truncating only the text nodes
  const preserveHtmlStructure = (html: string, maxLength: number): string => {
    let result = '';
    let truncatedIndex = 0;

    const traverseNode = (node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.nodeValue || '';

        if (keepWhitespaces) {
          text = text.replace(/\s/g, ' ');
        }

        const remainingLength = maxLength - truncatedIndex;
        if (text.length > remainingLength) {
          result += text.slice(0, remainingLength) + '...';
          truncatedIndex += remainingLength;
        } else {
          result += text;
          truncatedIndex += text.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = (node as Element).nodeName.toLowerCase();
        if (tagName === 'br') {
          result += '<br/>'; // Preserve <br/> tags
        } else {
          result += `<${tagName}${Array.from((node as Element).attributes)
            .map((attr) => ` ${attr.name}="${attr.value}"`)
            .join('')}>`;
          node.childNodes.forEach(traverseNode);
          result += `</${tagName}>`;
        }
      }
    };

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.body.childNodes.forEach(traverseNode);
    return result;
  };

  // Get raw text without HTML tags for truncation purposes
  const plainText = stripHtmlTags(html);
  const truncatedText = truncateText(plainText, maxLength, byWords);

  // Rebuild the HTML structure with the truncated text
  return preserveHtmlStructure(html, maxLength);  
};

// const truncateHtml = (htmlString, maxLength) => {
//     const tempDiv = document.createElement("div");
//     tempDiv.innerHTML = htmlString;

//     // Convert the HTML to plain text to determine the length
//     const text = tempDiv.innerText || tempDiv.textContent;

//     // If the text is shorter than maxLength, return the original HTML
//     if (text.length <= maxLength) {
//       return htmlString;
//     }

//     // Truncate the text while preserving HTML
//     let truncatedText = '';
//     let lengthCount = 0;

//     const walk = (node) => {
//       if (lengthCount >= maxLength) return;

//       if (node.nodeType === Node.TEXT_NODE) {
//         const remainingLength = maxLength - lengthCount;
//         const textContent = node.textContent;

//         if (textContent.length > remainingLength) {
//           truncatedText += textContent.slice(0, remainingLength) + '...';
//           lengthCount += remainingLength;
//         } else {
//           truncatedText += textContent;
//           lengthCount += textContent.length;
//         }
//       } else if (node.nodeType === Node.ELEMENT_NODE) {
//         truncatedText += `<${node.tagName.toLowerCase()}>`;
//         for (const child of node.childNodes) {
//           walk(child);
//           if (lengthCount >= maxLength) {
//             break;
//           }
//         }
//         truncatedText += `</${node.tagName.toLowerCase()}>`;
//       }
//     };

//     // walk(tempDiv);
//     for (const child of tempDiv.childNodes) {
//         walk(child);
//         if (lengthCount >= maxLength) break; // Stop if maxLength is reached
//     }

//     return truncatedText;
// };

export const responsiveClass = ({text, charLimits = { min: 8, mid: 40, max: 112 }, defaulFontClass='', tag=''}) => {
    // const [className, setClassName] = useState('c1'); // Default to c1
    const [className, setClassName] = useState(defaulFontClass);
    const [tagName, setTagName] = useState(tag);
    const [isTrim, setIsTrim] = useState(false);
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    const {
      sanityStore:{
        sanityPageData
      }
    } = useStores();
  
    // Text Trunkcate Logic From Sanity
    const isIgnoreTextTruncate = sanityPageData?.ignoreTextTruncate || false;
   
    useEffect(() => {
      if(!isIgnoreTextTruncate){
        if (tempDiv.innerText.length < charLimits.min) {
          // setClassName('error'); // Optional: handle too short text
          setClassName(defaulFontClass);
          setTagName(tag);
        } else if (tempDiv.innerText.length > charLimits.max) {
            // setClassName('c3'); // If more than 112 characters
            setClassName(classTagDownGrader(defaulFontClass));
            setTagName(classTagDownGrader(tag));
            setIsTrim(true);
        } else if (tempDiv.innerText.length > charLimits.mid) {
            // setClassName('c2'); // If between 40 and 112 characters
            setClassName(classTagDownGrader(defaulFontClass));
            setTagName(classTagDownGrader(tag));
        } else {
            // setClassName('c1'); // Less than or equal to 40 characters
            setClassName(defaulFontClass);
            setTagName(tag);
        }
      }
        
    }, [text, charLimits, isIgnoreTextTruncate]);

    return {className, tagName, isTrim};
    //return {defaulFontClass, tag, isTrim}
};
